import Footer from "../../components/Footer/Footer";
import Header from "../../components/Header/Header";
import ListDisplay from "../../components/ListDisplay/ListDisplay";
import { collection, query, where, getDocs, documentId, DocumentData} from "firebase/firestore";
import { useEffect, useState } from "react";
import { db } from "../../service";
import IList from '../../types/IList'

export default function CurrentShoppingList() {

    const id = window.location.toString().split("/")[4];
    let model: DocumentData | IList = {}
    const [list, setList] = useState(model);
    
    
async function getListById() {
    const q = query(collection(db, "lists"), where(documentId(), "==", id));

    const querySnapshot = await getDocs(q);
    
    querySnapshot.forEach((doc) => {
        let objList = doc.data()
        setList(objList);
});
}

getListById();

    return(
        <>
    
            <Header />

            {list.title !== undefined && <ListDisplay id={id} completed={list.completed} createdAt={list.createdAt} items={list.items} title={list.title}  />}
            <Footer />
        </>
    );
}